module.exports = __webpack_public_path__ + "img/file-upload-modal.f33dd933.png";